import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, NgZone, OnChanges, OnInit, Output, SimpleChange, SimpleChanges, ViewChild } from '@angular/core';
import { IDropdownField, YearDetailsModel, YearPickerDataModel } from './model/IDropdown';
import { Observable, Subject, } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { catchError, debounceTime, delay, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { FormControl } from '@angular/forms';
import { concat } from 'rxjs/observable/concat';
import { NgSelectComponent } from '@ng-select/ng-select';
import { OrdersService } from '../../services/orders/orders.service';

@Component({
  selector: 'app-dropdown-field-box',
  templateUrl: './dropdown-field-box.component.html',
  styleUrls: ['./dropdown-field-box.component.scss']
})
export class DropdownFieldBoxComponent implements OnInit, OnChanges {
  @Output() outputKeyword: EventEmitter<any> = new EventEmitter();
  @Output() searchKeyword: EventEmitter<string> = new EventEmitter();
  @Output() isValidation: EventEmitter<boolean> = new EventEmitter();
  @Output() onScrollEvent: EventEmitter<any> = new EventEmitter();
  @Output() onTabPress: EventEmitter<string> = new EventEmitter();
  @Output() onEnterPress: EventEmitter<string> = new EventEmitter();
  @Input() inputValue: any;
  @Input() noSearch: any;
  @Input() isSearchByApi: any = false;
  @Input() isSearchStatus: boolean;
  @Input() yearDropdownDetails: YearDetailsModel = {
    yearFrom: 2000,
    yearTo: 2030,
    isShowFromToYear: true
  }
  people$: Observable<any[]>;
  peopleLoading = false;
  customerId: any
  peopleInput$ = new Subject<string>();
  selectedPersons: any[] = <any>[{ name: 'Karyn Wright' }, { name: 'Other' }];
  @Input() fieldDetails: IDropdownField = {
    lable: 'Email',
    placeholder: 'Enter Email',
    isServerError: true,
    serverErrorText: 'Email is required',
    isSearch: true,
    dropdownList: [
      {
        name: 'option1',
        value: "1"
      },
      {
        name: 'option1',
        value: "1"
      },
      {
        name: 'option1',
        value: "1"
      }
    ]
  };
  @Input() formSubmitted: boolean = false;
  @Input() selectedItem: any;
  searchValue: any;
  @Input() disabled: boolean = false;
  @ViewChild('select') select: NgSelectComponent;

  constructor(private ngZone: NgZone, private el: ElementRef,
    private translate: TranslateService,
    private orderService: OrdersService) {
    this.peopleInput$.pipe(
      debounceTime(300), // Adjust the debounce time as needed (e.g., 300 milliseconds)
      // distinctUntilChanged()
    ).
      subscribe((newTerm) => {
        this.searchKeyword.emit(newTerm);
        this.searchValue = newTerm
      });
    this.people$ = this.peopleInput$.pipe(
      map((term) => this.searchPeople(term))
    )
  }
  ngOnInit(): void {
    if (this.fieldDetails.isYearDropdown) {
      this.fieldDetails.dropdownList = this.setYearDropdownList();
    }
  }

  private searchPeople(term: string | null): any[] {
    const searchTerm = term ? term : '';
    return this.fieldDetails.dropdownList.filter((person) => {
      return person.name.toLowerCase().startsWith(searchTerm.toLowerCase());
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.ngZone.runOutsideAngular(() => {
      if ((!changes.fieldDetails && (changes.inputValue && changes.inputValue.firstChange))) {
        return;
      }

      let fieldDetails: any;
      if (!changes.fieldDetails) {
        fieldDetails = this.fieldDetails;
        this.people$ = of(this.fieldDetails.dropdownList);
      } else {
        fieldDetails = changes.fieldDetails.currentValue;
        this.people$ = of(this.fieldDetails.dropdownList);
      }
      if (fieldDetails.isFocus == true) {
        this.setFocus();
      }
      const matchingItem = fieldDetails.dropdownList && fieldDetails.dropdownList.find(item => {
        if (this.fieldDetails.isValueBind) {
          return (item.value === this.inputValue);
        } else {
          return item.name === this.inputValue;
        }
      });
      this.selectedItem = matchingItem;
      // if (!this.inputValue) {
      //   this.inputValue = null;
      // }

    });

  }

  onSelect(event: any) {
    if (event) {
      if ((this.isSearchByApi || this.fieldDetails.isFullObject)
        && !this.fieldDetails.isMultipleSelect) {
        this.selectedItem = event;
        this.customerId = event.value
        this.inputValue = this.fieldDetails.isValueBind ? event.value : event.name;
        this.orderService.setCustomerId(this.customerId);
        this.outputKeyword.emit(event);
      } else if (this.fieldDetails.isMultipleSelect) {
        this.inputValue = event;
        if (this.fieldDetails.isFullObject) {
          this.outputKeyword.emit(event);
        }
        else {
          const idList = event.map(x => x.value);
          this.outputKeyword.emit(idList);
        }
      }
      else {
        this.inputValue = this.fieldDetails.isValueBind ? event.value : event.name;
        this.outputKeyword.emit(this.inputValue);
      }
    } else {
      this.outputKeyword.emit(event);
    }
  }

  translatorFn(value) {
    return this.translate.instant(value);
  }

  setYearDropdownList = (): Array<YearPickerDataModel> => {
    this.yearDropdownDetails.yearFrom = this.yearDropdownDetails.yearFrom ? this.yearDropdownDetails.yearFrom : (new Date().getFullYear() - 10);
    this.yearDropdownDetails.yearTo = this.yearDropdownDetails.yearTo ? this.yearDropdownDetails.yearTo : (new Date().getFullYear() + 10);

    const dropdownList: Array<YearPickerDataModel> = [];
    const yearTo = this.yearDropdownDetails.isShowFromToYear ? this.yearDropdownDetails.yearTo : this.yearDropdownDetails.yearTo + 1;
    for (let startYear = this.yearDropdownDetails.yearFrom; startYear < yearTo; startYear++) {
      let value: YearPickerDataModel;
      if (this.yearDropdownDetails.isShowFromToYear) {
        value = {
          name: startYear + " - " + (startYear + 1),
          startYear: startYear,
          endYear: (startYear + 1),
        }
      }
      else {
        value = {
          name: startYear,
          startYear: startYear,
          endYear: startYear,
        }
      }
      dropdownList.push(value);
    }
    return dropdownList;
  }

  customSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.name.toLowerCase().indexOf(term) > -1;
  }

  onTab(event) {
    this.onTabPress.emit(event);
  }

  onEnter(event) {
    this.onEnterPress.emit(event);
  }

  onSearch(event) {
    this.searchKeyword.emit(event);
  }

  onScrollToEnd() {
    this.onScrollEvent.emit(this.searchValue)
    console.log('Scroll end');
  }

  onScroll({ end }) {
    console.log('Scroll on');
    // if (this.isSearchStatus || this.photos.length <= this.photosBuffer.length) {
    //     return;
    // }

    // if (end + this.numberOfItemsFromEndBeforeFetchingMore >= this.photosBuffer.length) {
    //     this.fetchMore();
    // }
  }

  setFocus = () => {
    this.select.focus();
  }

}
